// extracted by mini-css-extract-plugin
export default {"main":"CreateCom_main__loyKP","companyplus":"CreateCom_companyplus__qrULy","active":"CreateCom_active__LkzjU","into":"CreateCom_into__Ix0ok","btn":"CreateCom_btn__dxnhB"};